export const PATH = {
  exportProxies: "/api/front/proxies/export",
  headers: "/api/v1/free-tools/headers",
  allCountries: "/api/front/countries",
  dataForPage: "/api/front/content/page",
  ssrCache: "/ssr/cache/",
  blogArticle: "/api/front/blog/article/slug",
  blogFacts: "/api/front/blog/articles/interesting",
  blog: "/api/front/blog/articles/short",
  subscribe: "/api/front/email-subscription/subscribe",
  html: "/api/front/property/html",
  languages: "/api/front/languages/active",
};
